import { useEffect, useState } from "react";
import { DiaryStatus, Dirary } from "../../types/dirary";
// import { Dirary } from "../../types/dirary";


export const useCheckDiaryList = (
  diaryList: Dirary[],
  fetchDiaryList: Dirary[]
) => {
  //削除する日報リスト
  const [deleteDiaryList, setDeleteDiaryList] = useState<Dirary[]>([]);
  //更新する日報リスト
  const [updateDiaryList, setUpdateDiaryList] = useState<Dirary[]>([]);
  //追加する日報リスト
  const [addDiaryList, setAddDiaryList] = useState<Dirary[]>([]);

  useEffect(() => {
    checkDiaryList();
    // console.log(
    //   "DEBUG_diaryList_all",
    //   "add",
    //   addDiaryList,
    //   "update",
    //   updateDiaryList,
    //   "delete",
    //   deleteDiaryList,
    //   "fetch",
    //   fetchDiaryList,
    //   "diary",
    //   diaryList
    // );
  }, [diaryList, fetchDiaryList]);

  const checkDiaryList = () => {
    //fetchDiaryListにidが存在せず、diaryListにidが存在し、そのidが0以下の場合追加リストに追加
    const deleteList: Dirary[] = [];
    const updateList: Dirary[] = [];
    const addList: Dirary[] = [];

    // FetchのIDセットを作成
    const fetchDiaryIdSet = new Set(fetchDiaryList.map((diary) => diary.id));
    const diaryIdSet = new Set(diaryList.map((diary) => diary.id));

    // 削除リストの作成
    fetchDiaryList.forEach((fetchDiary) => {
      if (!diaryIdSet.has(fetchDiary.id)) {
        deleteList.push(fetchDiary);
      }
    });

    // 更新リストの作成
    fetchDiaryList.forEach((fetchDiary) => {
      const correspondingDiary = diaryList.find(
        (diary) => diary.id === fetchDiary.id
      );
      if (
        correspondingDiary //&&
        //JSON.stringify(fetchDiary) !== JSON.stringify(correspondingDiary)
      ) {
        updateList.push(correspondingDiary);
      }
    });

    // 追加リストの作成
    diaryList.forEach((diary) => {
      if (!fetchDiaryIdSet.has(diary.id) && diary.id <= 0) {
        addList.push(diary);
      }
    });

    setDeleteDiaryList(deleteList);
    setUpdateDiaryList(updateList);
    setAddDiaryList(addList);
  };

  //デバッグ用
  useEffect(() => {
    console.log(
      "DEBUG_diaryList_all",
      "add",
      addDiaryList,
      "update",
      updateDiaryList,
      "delete",
      deleteDiaryList,
      "fetch",
      fetchDiaryList,
      "diary",
      diaryList
    );
  }, [
    deleteDiaryList,
    updateDiaryList,
    addDiaryList,
    diaryList,
    fetchDiaryList,
  ]);
  return { deleteDiaryList, updateDiaryList, addDiaryList };
};
